import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/forgot/page.tsx");
